export default "__VITE_ASSET__RKn1SZm7__"